import { render, staticRenderFns } from "./AssetCategoryTable.vue?vue&type=template&id=b097d2ac&scoped=true&"
import script from "./AssetCategoryTable.vue?vue&type=script&lang=js&"
export * from "./AssetCategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./AssetCategoryTable.vue?vue&type=style&index=0&id=b097d2ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b097d2ac",
  null
  
)

export default component.exports